module.exports = __webpack_public_path__ + "static/media/2-BREAK-THE-CYCLE.2ea83570.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/2-BREAK-THE-CYCLE.pdf
// module id = 154
// module chunks = 0